import React from "react";
import { Stack } from "@mui/material";
import AgendaSummaryView from "../../components/agenda/AgendaSummaryView";
import { fetchMyAgenda } from "../../methods/agenda/agendaRequests";

export default function AgendaAdminPage() {
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState("");
  const [agenda, setAgenda] = React.useState({ summary: null, items: [] });

  const loadAgenda = React.useCallback(async () => {
    setLoading(true);
    setError("");

    const response = await fetchMyAgenda();

    if (!response?.success) {
      setAgenda({ summary: null, items: [] });
      setError(response?.error || "Failed to load agenda.");
      setLoading(false);
      return;
    }

    setAgenda({
      summary: response.data?.summary || null,
      items: Array.isArray(response.data?.items) ? response.data.items : [],
    });
    setLoading(false);
  }, []);

  React.useEffect(() => {
    loadAgenda();
  }, [loadAgenda]);

  return (
    <Stack spacing={2}>
      <AgendaSummaryView
        title="Agenda"
        subtitle="View appointments, class bookings, and class sessions day by day."
        loading={loading}
        error={error}
        agenda={agenda}
        onRefresh={loadAgenda}
      />
    </Stack>
  );
}
